<template>
  <div class="panel wraper panel-gray centered">
    <div class="panel-header">
      <div class="panel-title">{{email}}</div>
    </div>
    <div class="panel-body">
      <p class="note">{{roles}}</p>
      <q-field
               :error="$v.tempProfile.screenname.$error"
               :error-label="$v.tempProfile.screenname | errorLabel"
      >
        <q-input  float-label="Имя пользователя" v-model.trim="tempProfile.screenname"  :autofocus="true"/>
      </q-field>
      <q-input readonly v-model="email" style="position: absolute; z-index: -1"/>
      <q-field
        :error="$v.tempProfile.password.$error"
        :error-label="$v.tempProfile.password | errorLabel"
      >
        <q-input float-label="Новый пароль" type="password" v-model="tempProfile.password" />
      </q-field>
      <q-field
        :error="$v.retype.$error"
        :error-label="$v.retype | errorLabel"
      >
        <q-input float-label="Повтор пароля" type="password" v-model="retype" />
      </q-field>
      <q-card v-if="notReader">
        <q-card-main>
        <template v-if="telcode">
          <p>
            <strong>Telegram</strong> не подключен. Для подключения отправьте <a href="https://tele.click/MTLinkBot" target="_blank">
            MTLink&nbsp;Telegram&nbsp;Bot
          </a> сообщение с текстом:
          </p>
          <label>
            <strong>user_{{telcode}}</strong>
            <q-btn small color="secondary" icon="fa-clipboard" @click="copy" label="Копировать" />
          </label>
          <p>
            После подключения изменения вступят в силу через несколько минут.
          </p>
        </template>
        <label v-else>
          <strong>Telegram</strong><span> подключен</span>
          <q-btn small outline color="warning" @click="telegramOff">Отключить</q-btn>
        </label>
        </q-card-main>
      </q-card>
    </div>
    <save-btn :notChanged="notChanged" :goView="goRoot" :doSave="doSave" />
  </div>
</template>

<style scoped>
  .centered {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
<script type="text/babel">
import _ from 'lodash';
import SaveBtn from 'components/save-btn.vue';
import { required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';

const pass = require('pwd');

pass.iterations(10);
pass.length(32);
export default {
  name: 'profile',
  components: {
    SaveBtn,
  },
  data() {
    return {
      iniProfile: {
        screenname: this.$store.state.user.screenname,
        password: '',
      },
      tempProfile: {
        screenname: this.$store.state.user.screenname,
        password: '',
      },
      retype: '',
      email: this.$store.state.user.email,
      roles: this.$store.state.user.roles.slice(1).join(', '),
    };
  },
  validations: {
    tempProfile: {
      screenname: {
        required: withParams({ message: 'Введите имя пользователя' }, required),
        minLength: withParams({ message: 'От 4 до 40 символов' }, minLength(4)),
        maxLength: withParams({ message: 'От 4 до 40 символов' }, maxLength(40)),
      },
      password: {
        minLength: withParams({ message: 'От 6 до 20 символов' }, minLength(6)),
        maxLength: withParams({ message: 'От 6 до 20 символов' }, maxLength(20)),
      },

    },
    retype: {
      sameAs: withParams({ message: 'Пароль и его повтор не совпадают' }, sameAs(function () {
        return this.tempProfile.password;
      })),
    },

  },
  computed: {
    telcode() {
      return this.$store.state.user.telcode;
    },
    notReader() {
      return !this.$store.getters.isReader;
    },
    notChanged() {
      return _.isEqual(this.iniProfile, this.tempProfile);
    },
  },
  mounted() {
    document.title = `${this.$store.state.user.screenname} - Профиль`;
  },
  beforeRouteLeave(to, from, next) {
    if (this && !this.notChanged) {
      this.$q.dialog({
        title: 'Внимание',
        'prevent-close': true,
        message: 'При переходе изменения не будут сохранены!',
        ok: {
          flat: true,
          color: 'warning',
          label: 'Перейти',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Остаться',
        },
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  methods: {
    copy() {
      this.$clipboard(`user_${this.telcode}`);
      this.$store.commit('pushError', {
        error: 'Скопировано!',
        message: `Код user_${this.telcode} скопирован в буфер обмена`,
        type: 'positive',
      });
    },
    telegramOff() {
      const it = this;

      this.$q.dialog({
        title: 'Предупреждение',
        'prevent-close': true,
        message: 'После отключения Telegram вы не будете получать уведомления!',
        ok: {
          flat: true,
          color: 'warning',
          label: 'Отключить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Не отключать',
        },
      })
        .then(() => {
          const data = {
            telid: null,
            telcode: 'xxxxxxxx'.replace(/[x]/g, () => (Math.random() * 16 | 0).toString(16)).toLowerCase(),
          };
          it.setUserData(data);
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    },
    goRoot() {
      // this turn off warning
      Object.assign(this.iniProfile, this.tempProfile);
      this.$router.push('/');
    },
    goSignIn() {
      // this turn off warning
      Object.assign(this.iniProfile, this.tempProfile);
      this.$router.push('/sign-in');
    },
    doSave() {
      this.$v.tempProfile.$touch();
      this.$v.retype.$touch();
      if (this.$v.tempProfile.$invalid || this.$v.retype.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      } else if (this.tempProfile.password) {
        console.log('hash password', this.tempProfile.password);
        pass.hash(this.tempProfile.password)
          .then((result) => {
            const data = {
              screenname: this.tempProfile.screenname,
              hapi_hash: result.hash,
              hapi_salt: result.salt,
            };
            console.log('hash result', data);
            this.setUserData(data);
          });
      } else {
        const data = { screenname: this.tempProfile.screenname };
        this.setUserData(data);
      }
    },
    setUserData(data) {
      this.$store.dispatch('setUserData', data)
        .then((res) => {
          console.log('setUserData res', res);
          if (data.hapi_hash) { // password changed
            this.goSignIn();
          } else if (data.screenname) {
            this.goRoot();
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.statusCode === 401) {
            this.goSignIn();
          } else if (err.statusCode === 409) {
            this.$store.commit('pushError', err);
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/profile.vue